import { render } from "./FragranceFormCard.vue?vue&type=template&id=70a5fb30&scoped=true"
import script from "./FragranceFormCard.vue?vue&type=script&lang=js"
export * from "./FragranceFormCard.vue?vue&type=script&lang=js"

import "./FragranceFormCard.vue?vue&type=style&index=0&id=70a5fb30&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a5fb30"]])

export default __exports__